import { RowFixed, UI } from '@cowprotocol/ui'

import { MenuList } from '@reach/menu-button'
import styled from 'styled-components/macro'

import { SettingsButton } from './Settings/styled'

// TODO: There's some duplication between this file and modules/trade/pure/Settings/styled.
// Using a re-export here until that's addressed properly.

export const StyledMenuButton = SettingsButton

export const StyledMenu = styled.div`
  margin: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  position: relative;
  border: none;
  text-align: left;
  color: inherit;

  ${RowFixed} {
    color: inherit;

    > div {
      color: inherit;
      opacity: 0.85;
    }
  }
`

export const MenuFlyout = styled(MenuList)`
  min-width: 20.125rem;
  background: var(${UI.COLOR_PRIMARY});
  box-shadow:
    0px 0px 1px rgba(0, 0, 0, 0.01),
    0px 4px 8px rgba(0, 0, 0, 0.04),
    0px 16px 24px rgba(0, 0, 0, 0.04),
    0px 24px 32px rgba(0, 0, 0, 0.01);
  border-radius: 12px;
  display: flex;
  flex-direction: column;
  font-size: 1rem;
  position: absolute;
  z-index: 100;
  color: inherit;
  box-shadow: ${({ theme }) => theme.boxShadow2};
  border-top: 1px solid var(${UI.COLOR_BORDER});
  background-color: var(${UI.COLOR_PAPER});
  color: inherit;
  padding: 0;
  margin: 0;
  top: 36px;
  right: 0;
  width: 280px;
`
